import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import LanguageToggle from './LanguageToggle';
import './Header.css';

const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header>
      <nav className="container">
        <Link to="/" className="logo" onClick={closeMobileMenu}>
          <img src="/Logo5.png" alt={t('nav.logoAlt')} className="logo-image" />
          <span className="logo-text">{t('nav.organizationName')}</span>
        </Link>

        {/* Desktop Navigation */}
        <div className="nav-container desktop-nav">
          <ul className="nav-links">
            <li><Link to="/" className={isActive('/') ? 'active' : ''}>{t('nav.home')}</Link></li>
            <li><Link to="/about" className={isActive('/about') ? 'active' : ''}>{t('nav.about')}</Link></li>
            <li><Link to="/campaigns" className={isActive('/campaigns') ? 'active' : ''}>{t('nav.campaigns')}</Link></li>
            <li><Link to="/donation" className={isActive('/donation') ? 'active' : ''}>{t('nav.donation')}</Link></li>
            <li><Link to="/stories" className={isActive('/stories') ? 'active' : ''}>{t('nav.stories')}</Link></li>
            <li><Link to="/involvement" className={isActive('/involvement') ? 'active' : ''}>{t('nav.involvement')}</Link></li>
            <li><Link to="/contact" className={isActive('/contact') ? 'active' : ''}>{t('nav.contact')}</Link></li>
          </ul>
          <LanguageToggle />
        </div>

        {/* Mobile Controls */}
        <div className="mobile-controls">
          <button
            className="hamburger-menu"
            onClick={toggleMobileMenu}
            aria-label="메뉴 열기"
          >
            <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} />
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <div className="mobile-menu-header">
            <LanguageToggle />
          </div>
          <ul className="mobile-nav-links">
            <li><Link to="/" className={isActive('/') ? 'active' : ''} onClick={closeMobileMenu}>{t('nav.home')}</Link></li>
            <li><Link to="/about" className={isActive('/about') ? 'active' : ''} onClick={closeMobileMenu}>{t('nav.about')}</Link></li>
            <li><Link to="/campaigns" className={isActive('/campaigns') ? 'active' : ''} onClick={closeMobileMenu}>{t('nav.campaigns')}</Link></li>
            <li><Link to="/donation" className={isActive('/donation') ? 'active' : ''} onClick={closeMobileMenu}>{t('nav.donation')}</Link></li>
            <li><Link to="/stories" className={isActive('/stories') ? 'active' : ''} onClick={closeMobileMenu}>{t('nav.stories')}</Link></li>
            <li><Link to="/involvement" className={isActive('/involvement') ? 'active' : ''} onClick={closeMobileMenu}>{t('nav.involvement')}</Link></li>
            <li><Link to="/contact" className={isActive('/contact') ? 'active' : ''} onClick={closeMobileMenu}>{t('nav.contact')}</Link></li>
          </ul>
        </div>

        {/* Overlay */}
        {isMobileMenuOpen && (
          <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
        )}
      </nav>
    </header>
  );
};

export default Header;
